import { render, staticRenderFns } from "./AppFrame.vue?vue&type=template&id=3250ec1c"
import script from "./AppFrame.vue?vue&type=script&lang=js"
export * from "./AppFrame.vue?vue&type=script&lang=js"
import style0 from "./AppFrame.vue?vue&type=style&index=0&id=3250ec1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports